import { Injectable } from '@angular/core';
import { ToastController, Platform, Events } from "ionic-angular";
import { Headers, Http } from "@angular/http";
import { OneSignal } from "@ionic-native/onesignal";
import { User } from '../../interfaces/user';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class UserService {

    sessionType: string = "guest";
    user: User;
    teams: any;

    constructor(private toastCtrl: ToastController, private platform: Platform, private _OneSignal: OneSignal, private events: Events) {
    }

    clearSession() {
        this.sessionType = "guest";
        this.user = null;
        this._OneSignal.setSubscription(false);
    }

    createToast(message: string) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 4000
        });

        toast.present();
    }

    getSessionType(): string {
        return this.sessionType;
    }

    getDebt() {
        return this.user.debt;
    }

    getUser(): User {
        return this.user;
    }

    initOneSignal(user: any) {
        this._OneSignal.startInit('27367d0e-ec98-4fce-9929-6fcb609d3e23');
        this._OneSignal.setSubscription(true);
        this._OneSignal.endInit();
        this._OneSignal.sendTags({
            "id": user.id,
            "name": user.name,
            "email": user.email,
            "teamId": user.teamId
        });
    }

    isTeamCode(codes: any, pass: string): boolean {
        let passwordsMatch = false;
        codes.forEach(element => {
            if (pass === element.$value) {
                passwordsMatch = true;
            }
        });
        return passwordsMatch;
    }

    startGuestSession() {
        this.sessionType = "guest";
    }

    startSession(user: any) {
        this.user = user
        this.sessionType = user.role;

        this.events.publish('user:loaded', user);
        
        if (this.platform.is('mobile')) {
            this.initOneSignal(user);
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/session-service/user-service.ts